import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";

export default function BottomSheet({ open, onOpenChange, children, className = "" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onOpenChange(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onOpenChange]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="fixed inset-0 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => onOpenChange(false)}
          />
          <motion.div
            className={`fixed inset-x-0 bottom-0 z-50 mx-auto flex max-w-[480px] flex-col ${className}`}
            style={{ backgroundColor: "rgba(51,51,51,0.5)", backdropFilter: "blur(30px)", WebkitBackdropFilter: "blur(30px)" }}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 34, stiffness: 340 }}
          >
            <div className="mx-auto mt-3 h-1.5 w-11 shrink-0 rounded-full bg-white/40" />
            {children}
            <div className="h-6 shrink-0" />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
